import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Front/Home";
import Updating from "./pages/Front/Updating";
import ScrollToTop from "./components/ScrollToTop";
function FrontPage(){const location=useLocation();return new URLSearchParams(location.search).get("page")==="updating"?<Updating/>:<Home/>}
function App(){return <Router><ScrollToTop/><Routes><Route path="/updating" element={<Updating/>}/><Route path="*" element={<FrontPage/>}/></Routes></Router>}
export default App;